import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { white } from '@qirapagos/lib/theme/colors'

const SidebarSkeleton = () => (
  <ContentLoader
    speed={3}
    interval={0}
    width="100%"
    height="100vh"
    viewBox="0 0 100% 100vh"
    backgroundColor="#e8e7f7"
    foregroundColor={white}
  >
    <Rect x="10%" y="5vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="17vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="24vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="31vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="38vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="45vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="52vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="59vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="66vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="73vh" rx="4" ry="4" width="80%" height="4vh" />
    <Rect x="10%" y="87vh" rx="4" ry="4" width="80%" height="4vh" />
  </ContentLoader>
)

export default SidebarSkeleton
